module.exports = __webpack_public_path__ + "static/img/downloadLogo.abf0f263.png";